<div *ngIf="(isLoggedIn$ | async) === false">
  <h1>{{'pwdReset.title' | translate}}</h1>
  <p class="mb-5" [innerHTML]="'pwdReset.header' | translate | replace: {url: '#/auth/login'}">
  </p>
  <ta-user-security [emailToken]='emailToken' [appKey]='appKey' [username]='username' [id]='id'></ta-user-security>
</div>